@if (!isLoading) {
  @for (item of addressesByType | keyvalue: keepOriginalOrder; track item.key) {
    @if (item.key && item.value.length) {
      <div class="details-section-title">
        <div class="title"><rkt-icon [name]="getAddressIconName(item.key)"></rkt-icon>{{ getAddressTitle(item.key) }}</div>
      </div>
      <div class="details-section address-section">
        <div class="details-row">
          @for (address of item.value; track address; let i = $index) {
            <app-details-item
              [isPrimary]="address.primary"
              [showPlaceholder]="isLoading"
              [label]="getAddressLabel(address, i)"
              [value]="
                address.type === 'SHIPPING' && !!getContactFullName(address)
                  ? getContactFullName(address)
                  : $safeNavigationMigration(address?.streetLine1)
              "
            >
              <ng-container>
                @if (address.type === 'SHIPPING' && !!getContactFullName(address)) {
                  <div class="address-margin">
                    {{ address?.streetLine1 }}
                  </div>
                }
                <div>{{ address?.streetLine2 }}</div>
                <div>{{ address?.cityName }}, {{ address?.stateCode }}</div>
                <div>{{ address?.zipCode }} {{ address?.countryCode }}</div>
              </ng-container>
            </app-details-item>
          }
        </div>
      </div>
    }
  }
} @else {
  <div class="details-section-title">
    <div class="title"><rkt-icon name="location"></rkt-icon>Address</div>
  </div>
  <div class="details-section address-section">
    <div class="details-row">
      <app-details-item [value]="" [showPlaceholder]="isLoading"></app-details-item>
    </div>
  </div>
}
